import { createContext, useContext } from 'react';

interface FormContextValue {
  isLoading: boolean;
  readOnly: boolean;
}

export const FormContext = createContext<FormContextValue>({
  isLoading: false,
  readOnly: false
});

export const useFormContext = () => useContext(FormContext);
